import React, { useState } from "react";
import Table from "../../../components/Table/TablePaginationFromApi";
import { useSelector, useDispatch } from "react-redux";
import { getOldHotels } from "../../../redux/actions/PartnerReportAction";

const OldHotels = (props) => {
    const dispatch = useDispatch();
    const { token, selectedMapping, filters } = props;
    const [perPage, setPerPage] = useState(10);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [column, setColumn] = useState();
    const [sortDirection, setSortDirection] = useState();
    const { oldhotels, loadingOldHotels, total } = useSelector((state) => ({
        oldhotels: state.partnerReportReducer.oldhotels?.hotels ?? [],
        total: state.partnerReportReducer.oldhotels?.total ?? 0,
        loadingOldHotels: state.partnerReportReducer.loadingOldHotels,
    }));

    const columns = [
        {
            id: "hotel_code",
            name: <div className="table-title">Hotel Code</div>,
            cell: (e) => {
                return <>{e?.hotel_code}</>;
            },
            sortable: true,
        },
        {
            id: "hotel_name",
            name: <div className="table-title">Name</div>,
            cell: (e) => {
                return <>{e?.hotel_name}</>;
            },
            sortable: true,
        },

        {
            id: "city",
            name: <div className="table-title">City</div>,
            cell: (e) => {
                return <>{e?.city}</>;
            },
            sortable: true,
        },
        {
            id: "country",
            name: <div className="table-title">Country</div>,
            cell: (e) => {
                return <>{e?.country}</>;
            },
            sortable: true,
        },
        {
            id: "address",
            name: <div className="table-title">Address</div>,
            cell: (e) => {
                return <>{e?.address}</>;
            },
            sortable: true,
        },
    ];

    const handlePageChange = (page) => {
        dispatch(
            getOldHotels(
                token,
                selectedMapping?.value,
                page,
                perPage,
                filterText,
                filters,
                column,
                sortDirection
            )
        );
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        dispatch(
            getOldHotels(
                token,
                selectedMapping?.value,
                page,
                newPerPage,
                filterText,
                filters,
                column,
                sortDirection
            )
        );
        setPerPage(newPerPage);
    };

    const handleSort = async (c, sortD) => {
        dispatch(
            getOldHotels(
                token,
                selectedMapping?.value,
                1,
                10,
                filterText,
                filters,
                c?.id,
                sortD
            )
        );
        setColumn(c?.id);
        setSortDirection(sortD);
    };

    return (
        <div style={{ marginTop: "15px" }}>
            <Table
                data={oldhotels}
                columns={columns}
                totalRows={total}
                handlePageChange={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                progressPending={loadingOldHotels}
                onFilter={() => {
                    setResetPaginationToggle(true);
                    dispatch(
                        getOldHotels(
                            token,
                            selectedMapping?.value,
                            1,
                            perPage,
                            filterText,
                            filters
                        )
                    );
                }}
                filterValue={filterText}
                handleClearFilter={() => {
                    setFilterText("");
                    setResetPaginationToggle(true);
                    dispatch(getOldHotels(token, 1, perPage, "", filters));
                }}
                onChange={(e) => {
                    setFilterText(e.target.value);
                    if (e.target.value === "") {
                        setResetPaginationToggle(true);
                        dispatch(
                            getOldHotels(
                                token,
                                selectedMapping?.value,
                                1,
                                perPage,
                                "",
                                filters
                            )
                        );
                    }
                }}
                filter={true}
                resetPaginationToggle={resetPaginationToggle}
                onSort={handleSort}
                sortServer={true}
            />
        </div>
    );
};

export default OldHotels;
